import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from "framer-motion"


function Home() {

    const contVar = {
        hidden: {
            opacity: 0,
            x: '100vw',
        },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                type: 'spring',
                delay: 2,
                duration: 2,
                ease: 'easeInOut'
            },
        },
    }

    const btnVar = {

        hover: {
            scale: 1.1,
            transition: {
                type: 'spring',
                duration: .5,
                duration: .3,
                yoyo: 8,
                color: 'transparent'
            },
        },
    }

    return (
        <motion.div className='home-div'
            initial='hidden'
            animate='visible'
            variants={contVar}
        >
            
            <motion.div className='bio-div'>
            <span className='bio-p'>Hi, my name is </span>
            <h1 style={{
                color: 'rgb(204,214,246)'
            }}><span>Tosin Alagbada.</span> <span>I build things for the web.</span></h1>
            <p>I'm a software developer who specializes in creating (and, on occasion, designing) amazing digital experiences. I'm open to new opportunities (paid internship/apprenticeship, full-time employment) to gain real-world experience by tackling meaningful problems and having a tangible impact on people's businesses, which is necessary to improve my sense of ownership, push me out of comfort zone, make me unafraid of the unfamiliar, and above all, to make me a better developer with skills to build my future telehealth startup.</p>
            <a href="tel:+2348062083584" style={{textDecoration: 'none'}}>
                <motion.button className='home-btn' type="submit"
                    variants={btnVar}
                    whileHover='hover'
                > <span><FontAwesomeIcon icon={["fas", "phone"]}  transform={{ rotate: 88 }} /></span> Get in touch</motion.button>
            </a>
            </motion.div>
            {/* <div  className='mail-div'>
                <a className='hr' href='mailto:alagbadatosin@gmail.com'>Connect with mail</a>
                <div className='hr hrr'>
                    <hr></hr>
                </div>
            </div> */}
        </motion.div>
    )
}

export default Home
